export default function RecipeFacts({ items = [] }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
      {items.map((item) => (
        <div key={item.label}>
          <p className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
            {item.label}
          </p>
          <p className="mt-1 text-primary-red font-semibold">{item.value}</p>
        </div>
      ))}
    </div>
  );
}
